module.exports = __webpack_public_path__ + "static/logo_italiadomani_pnrr-1cb0e83963c6515da3b4af746cbf753c.png";